import {PageTitle} from "../../_components";
import React, {useState} from "react";
import {Link, useParams} from "react-router-dom";
import {useAlert, useAuth} from "../../../context";
import {useGetJson} from "../../../hooks";
import {config, endpoints} from "../../../utils2";
import {Alert, Badge, Button, Figure, Modal, Stack} from "react-bootstrap";
import {isoTimestampToReadableDateOnly} from "../admin/utilities/readableDate";
import {useBasket} from "../../shop/useShop";

export function SubscriptionView() {
    const {uid, sid} = useParams()
    const {authToken} = useAuth()
    const [show, setShow] = useState(false);

    const [subsDet, loadingSubDetails, errorSubDetails, clearErrorSubDetails] = useGetJson(endpoints.subscription.get(sid), authToken?.jwt)
    const subDetails = subsDet?.data

    const {addArticle, errorArticle, loadingArticle, clearErrorArticle} = useBasket(false)
    const {success} = useAlert()

    function handleSubmit() {
        addArticle(subDetails?.product_id, 1)
            .then(msg => {
                success(<span><strong>{subDetails?.title}</strong> has been added to your <Alert.Link as={Link} to="/shop/cart">Cart</Alert.Link>!</span>)
            })
            .catch(console.warn)
    }

    return <>
        <Alert show={errorSubDetails} dismissible onClose={clearErrorSubDetails}>{errorSubDetails}</Alert>
        <Alert show={errorArticle} dismissible onClose={clearErrorArticle}>{errorArticle}</Alert>

        <PageTitle title="Subscription Details"></PageTitle>

        <div className="d-flex flex-column flex-md-row align-items-start gap-md-5">

            <Figure className="" style={{cursor: "pointer"}} onClick={() => setShow(true)}>
                <Figure.Image
                    src={config.get_public_media(subDetails?.media_path, "medium")}
                    alt={subDetails?.title}
                    rounded
                    height="300px"
                    width="300px"
                    loading="lazy"
                />
            </Figure>
            <ShowFigure mediaPath={subDetails?.media_path} show={show} setShow={setShow}/>

            <div>
                <div className="fw-semibold text-primary fs-3 mb-2">{subDetails?.title}</div>

                <div className="d-flex gap-2 align-items-center">
                    <Badge bg={subDetails?.is_active ? "success" : "danger"}>{subDetails?.is_active ? "ACTIVE" : "INACTIVE"}</Badge>
                    {subDetails?.is_active && <div className="text-wrap fs-6 text-muted">{`${subDetails?.remaining_days} ${subDetails?.remaining_days > 1 ? "days" : "day"}  remaining`}</div>}
                </div>

                {subDetails?.is_active && <div className="text-wrap fs-6 ">{`Valid until ${isoTimestampToReadableDateOnly(subDetails?.expiry_date)}`}</div>}

            </div>
        </div>

        <div className="mt-4 mt-md-0"/>

        <div>{subDetails?.summary}</div>

        <div className="mt-4"/>

        <Link to={`/shop/detail/${subDetails?.product_id}`}
              className="text-secondary link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">
            <div >SKU: {subDetails?.SKU}</div>
        </Link>

        <Link to={`/backend/order/${uid}/${subDetails?.id}`}
              className="text-secondary link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">
            <div>Order n.: {subDetails?.order_number}</div>
        </Link>

        <Stack direction="horizontal" gap="2" className="py-3 justify-content-end">
            <Button variant="info" as={Link} to={`/backend/order/${uid}/${subDetails?.id}`}>View order</Button>
            <Button variant="primary" onClick={handleSubmit} disabled={loadingArticle}>Reorder</Button>
        </Stack>
    </>
}

function ShowFigure({mediaPath, show, setShow}) {
    return <>
        <Modal show={show} onHide={() => setShow(false)} centered size="lg">
            <Modal.Body className="text-center">
                <Figure>
                    <Figure.Image
                        src={config.get_public_media(mediaPath, "medium")}
                    />
                </Figure>
            </Modal.Body>
        </Modal>
    </>
}